/**
 * Critical Illness coverage skeleton
 */

import {
  RfpCoverage,
  CoverageTypeEnum,
  BenefitPlanTypeEnum,
  PlanOptionNameEnum,
  FundingTypeEnum,
  RfpBenefitPlan,
} from "../../types/rfp.api.types";

export const getCriticalIllnessSkeleton = (): Partial<RfpCoverage> => ({
  type: CoverageTypeEnum.CRITICAL_ILLNESS,
  status: "quoted",
  notes: "",
  benefitPlans: [
    {
      identifier: "criticalIllness-plan-1",
      name: "Critical Illness Plan",
      numberOfLives: 0,
      type: BenefitPlanTypeEnum.NOT_APPLICABLE,
      policyPeriod: "newBusiness",
      fundingType: FundingTypeEnum.FULLY_INSURED,
      participationRequirements: "",
      rateGuarantee: undefined,
      rateCap: "",
      optionName: PlanOptionNameEnum.NOT_APPLICABLE,
      benefitClassAvailability: [],
      rateSchedule: [],
      benefits: {
        employerContribution: undefined,
        employeeBenefit: {
          description: { type: "increments", incrementAmount: 0 },
          maximum: { type: "flatAmount", amount: 0 },
          guaranteeIssue: { type: "flatAmount", amount: 0 },
        },
        spouseBenefit: {
          description: { type: "increments", incrementAmount: 0 },
          maximum: { type: "flatAmount", amount: 0 },
          guaranteeIssue: { type: "flatAmount", amount: 0 },
        },
        childBenefit: {
          description: { type: "flatAmount", amount: 0 },
        },
        illnessCoverage: { type: "allCoveredIllnesses", percentage: 0 },
        maximumPayout: "",
        recurrenceBenefit: "",
        portability: "",
      },
    } as RfpBenefitPlan,
  ],
});
